import React from "react";
import FamilyHousingInfo from "./FamilyHousingInfo";

interface FamilyHousingProps {
  form: any;
  housingTypes: any;
  housingStates: any;
}

const FamilyHousing = ({
  form,
  housingTypes,
  housingStates,
}: FamilyHousingProps) => {
  return (
    <div style={{ padding: "2rem" }}>
      <FamilyHousingInfo
        form={form}
        housingTypes={housingTypes}
        housingStates={housingStates}
      />
    </div>
  );
};

export default FamilyHousing;
